/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApproveClubhouseReservationRequestRequest,
  CreateClubhouseReservationRequest200Response,
  CreateClubhouseReservationRequestRequest,
  ListRequestsForAccount200Response,
  RejectClubhouseReservationRequestRequest,
} from '../models/index';
import {
    ApproveClubhouseReservationRequestRequestFromJSON,
    ApproveClubhouseReservationRequestRequestToJSON,
    CreateClubhouseReservationRequest200ResponseFromJSON,
    CreateClubhouseReservationRequest200ResponseToJSON,
    CreateClubhouseReservationRequestRequestFromJSON,
    CreateClubhouseReservationRequestRequestToJSON,
    ListRequestsForAccount200ResponseFromJSON,
    ListRequestsForAccount200ResponseToJSON,
    RejectClubhouseReservationRequestRequestFromJSON,
    RejectClubhouseReservationRequestRequestToJSON,
} from '../models/index';

export interface ApproveClubhouseReservationRequestOperationRequest {
    requestID: string;
    approveClubhouseReservationRequestRequest: ApproveClubhouseReservationRequestRequest;
    pageNumber?: number;
    pageSize?: number;
}

export interface CreateClubhouseReservationRequestOperationRequest {
    createClubhouseReservationRequestRequest: CreateClubhouseReservationRequestRequest;
    pageNumber?: number;
    pageSize?: number;
}

export interface DeleteClubhouseReservationRequestRequest {
    requestID: string;
    pageNumber?: number;
    pageSize?: number;
}

export interface ListPendingClubhouseReservationRequestsRequest {
    pageNumber?: number;
    pageSize?: number;
}

export interface ListRequestsForAccountRequest {
    accountID: string;
    pageNumber?: number;
    pageSize?: number;
}

export interface RejectClubhouseReservationRequestOperationRequest {
    requestID: string;
    rejectClubhouseReservationRequestRequest: RejectClubhouseReservationRequestRequest;
    pageNumber?: number;
    pageSize?: number;
}

/**
 * 
 */
export class ReserveClubhouseRequestsApi extends runtime.BaseAPI {

    /**
     * Approve a clubhouse reservation request
     * Approve Request
     */
    async approveClubhouseReservationRequestRaw(requestParameters: ApproveClubhouseReservationRequestOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateClubhouseReservationRequest200Response>> {
        if (requestParameters['requestID'] == null) {
            throw new runtime.RequiredError(
                'requestID',
                'Required parameter "requestID" was null or undefined when calling approveClubhouseReservationRequest().'
            );
        }

        if (requestParameters['approveClubhouseReservationRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'approveClubhouseReservationRequestRequest',
                'Required parameter "approveClubhouseReservationRequestRequest" was null or undefined when calling approveClubhouseReservationRequest().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['page[number]'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page[size]'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/clubhouse-reservation-requests/{requestID}/approve`.replace(`{${"requestID"}}`, encodeURIComponent(String(requestParameters['requestID']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApproveClubhouseReservationRequestRequestToJSON(requestParameters['approveClubhouseReservationRequestRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateClubhouseReservationRequest200ResponseFromJSON(jsonValue));
    }

    /**
     * Approve a clubhouse reservation request
     * Approve Request
     */
    async approveClubhouseReservationRequest(requestParameters: ApproveClubhouseReservationRequestOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateClubhouseReservationRequest200Response> {
        const response = await this.approveClubhouseReservationRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new clubhouse reservation request
     * Create Clubhouse Reservation Request
     */
    async createClubhouseReservationRequestRaw(requestParameters: CreateClubhouseReservationRequestOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateClubhouseReservationRequest200Response>> {
        if (requestParameters['createClubhouseReservationRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'createClubhouseReservationRequestRequest',
                'Required parameter "createClubhouseReservationRequestRequest" was null or undefined when calling createClubhouseReservationRequest().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['page[number]'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page[size]'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/clubhouse-reservation-requests`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClubhouseReservationRequestRequestToJSON(requestParameters['createClubhouseReservationRequestRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateClubhouseReservationRequest200ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new clubhouse reservation request
     * Create Clubhouse Reservation Request
     */
    async createClubhouseReservationRequest(requestParameters: CreateClubhouseReservationRequestOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateClubhouseReservationRequest200Response> {
        const response = await this.createClubhouseReservationRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a clubhouse reservation request
     * Delete Request
     */
    async deleteClubhouseReservationRequestRaw(requestParameters: DeleteClubhouseReservationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateClubhouseReservationRequest200Response>> {
        if (requestParameters['requestID'] == null) {
            throw new runtime.RequiredError(
                'requestID',
                'Required parameter "requestID" was null or undefined when calling deleteClubhouseReservationRequest().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['page[number]'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page[size]'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/clubhouse-reservation-requests/{requestID}`.replace(`{${"requestID"}}`, encodeURIComponent(String(requestParameters['requestID']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateClubhouseReservationRequest200ResponseFromJSON(jsonValue));
    }

    /**
     * Delete a clubhouse reservation request
     * Delete Request
     */
    async deleteClubhouseReservationRequest(requestParameters: DeleteClubhouseReservationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateClubhouseReservationRequest200Response> {
        const response = await this.deleteClubhouseReservationRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List pending requests
     * List Pending Requests
     */
    async listPendingClubhouseReservationRequestsRaw(requestParameters: ListPendingClubhouseReservationRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListRequestsForAccount200Response>> {
        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['page[number]'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page[size]'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/clubhouse-reservation-requests/pending`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListRequestsForAccount200ResponseFromJSON(jsonValue));
    }

    /**
     * List pending requests
     * List Pending Requests
     */
    async listPendingClubhouseReservationRequests(requestParameters: ListPendingClubhouseReservationRequestsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListRequestsForAccount200Response> {
        const response = await this.listPendingClubhouseReservationRequestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all clubhouse reservation requests for a specific account
     * List Requests for Account
     */
    async listRequestsForAccountRaw(requestParameters: ListRequestsForAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListRequestsForAccount200Response>> {
        if (requestParameters['accountID'] == null) {
            throw new runtime.RequiredError(
                'accountID',
                'Required parameter "accountID" was null or undefined when calling listRequestsForAccount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['page[number]'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page[size]'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/clubhouse-reservation-requests/account/{accountID}`.replace(`{${"accountID"}}`, encodeURIComponent(String(requestParameters['accountID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListRequestsForAccount200ResponseFromJSON(jsonValue));
    }

    /**
     * List all clubhouse reservation requests for a specific account
     * List Requests for Account
     */
    async listRequestsForAccount(requestParameters: ListRequestsForAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListRequestsForAccount200Response> {
        const response = await this.listRequestsForAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reject a clubhouse reservation request
     * Reject Request
     */
    async rejectClubhouseReservationRequestRaw(requestParameters: RejectClubhouseReservationRequestOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateClubhouseReservationRequest200Response>> {
        if (requestParameters['requestID'] == null) {
            throw new runtime.RequiredError(
                'requestID',
                'Required parameter "requestID" was null or undefined when calling rejectClubhouseReservationRequest().'
            );
        }

        if (requestParameters['rejectClubhouseReservationRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'rejectClubhouseReservationRequestRequest',
                'Required parameter "rejectClubhouseReservationRequestRequest" was null or undefined when calling rejectClubhouseReservationRequest().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['page[number]'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page[size]'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/clubhouse-reservation-requests/{requestID}/reject`.replace(`{${"requestID"}}`, encodeURIComponent(String(requestParameters['requestID']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RejectClubhouseReservationRequestRequestToJSON(requestParameters['rejectClubhouseReservationRequestRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateClubhouseReservationRequest200ResponseFromJSON(jsonValue));
    }

    /**
     * Reject a clubhouse reservation request
     * Reject Request
     */
    async rejectClubhouseReservationRequest(requestParameters: RejectClubhouseReservationRequestOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateClubhouseReservationRequest200Response> {
        const response = await this.rejectClubhouseReservationRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
